module.exports = __webpack_public_path__ + "static/media/loadbar.7041c03b.png";